<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Secuencia
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Secuencias

    v-dialog(v-model='dialog', persistent max-width='400px')
      v-card
        v-card-title.justify-center Ajustar correlativo
        v-card-text
          v-form(ref="form", v-model="valid")
            v-text-field(
              v-model="form.id"
              label="ID"
              readonly
              dense
              outlined
            )
            v-text-field(
              v-model.number="form.valor"
              label="Valor"
              type="number"
              :rules="valorRules"
              dense
              outlined
              required
            )
        v-card-actions
          v-spacer
          v-btn(color="grey" text @click="closeDialog") Cancelar
          v-btn(color="primary" :loading="saving" @click="save" :disabled="!valid") Guardar

    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
            v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
                span.white--text Lista de Secuencias
        v-data-table.elevation-1(:headers='headers', :items="resultados", :loading="loading", style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td {{ props.item.id || props.item._id }}
            td {{ props.item.valor }}
            td
              v-btn(icon small color="primary" @click="editItem(props.item)")
                v-icon edit
</template>

<script>
import Api from "@/services/methods";

export default {
  name: "Secuencia",
  data: () => ({
    loading: false,
    saving: false,
    dialog: false,
    valid: true,
    resultados: [],
    headers: [
      { text: "ID", value: "id" },
      { text: "Valor", value: "valor" },
      { text: "Acciones", sortable: false }
    ],
    form: {
      id: "",
      valor: null
    },
    valorRules: [
      v => v !== null && v !== undefined || 'El valor es requerido',
      v => !isNaN(v) || 'Debe ser numérico'
    ]
  }),
  created() {
    this.verificacion();
    this.initialize();
  },
  methods: {
    verificacion() {
      // usa permisos de ruta "Secuencia" si existen; si no, permite solo ver
      if (!this.$store || !this.$store.state || !this.$store.state.adminsafiro) return;
      const permisos = this.$store.state.adminsafiro.permisos || [];
      const ruta = permisos.find(p => p.ruta === "Secuencia");
      if (!ruta) return;
      const puedeModificar = ruta.accion && ruta.accion.includes("Modificar");
      this.puedeModificar = puedeModificar;
    },
    initialize() {
      this.loading = true;
      Api.get("secuencia").then(res => {
        this.resultados = res.data || [];
      }).catch(error => {
        console.error('Error cargando secuencias:', error);
        this.$swal && this.$swal.fire("Error", "No se pudieron cargar las secuencias", "error");
      }).finally(() => {
        this.loading = false;
      });
    },
    editItem(item) {
      this.form = {
        id: item.id || item._id,
        valor: item.valor
      };
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      this.form = { id: "", valor: null };
      this.$refs.form && this.$refs.form.resetValidation();
    },
    save() {
      if (!this.$refs.form || !this.$refs.form.validate()) return;
      this.saving = true;
      const targetId = this.form.id;
      Api.put(`secuencia/${targetId}`, { valor: this.form.valor }).then(res => {
        this.$swal && this.$swal.fire("Listo", "Secuencia actualizada", "success");
        this.dialog = false;
        this.initialize();
      }).catch(error => {
        console.error('Error actualizando secuencia:', error);
        this.$swal && this.$swal.fire("Error", "No se pudo actualizar la secuencia", "error");
      }).finally(() => {
        this.saving = false;
      });
    }
  }
};
</script>
